import { render, staticRenderFns } from "./StartCount.vue?vue&type=template&id=87f566f4&scoped=true&"
import script from "./StartCount.vue?vue&type=script&lang=js&"
export * from "./StartCount.vue?vue&type=script&lang=js&"
import style0 from "./StartCount.vue?vue&type=style&index=0&id=87f566f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f566f4",
  null
  
)

export default component.exports